import { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import IconCheck from './icon_check.svg';
import s from './index.module.scss';

export const Option = props => {
  const { innerProps, isSelected, data: period } = props;

  return (
    <div {...innerProps} className={s.option}>
      <span>{period.label}</span>
      {isSelected && <img src={IconCheck} alt="check" width={24} height={24} />}
    </div>
  );
};

export const MenuList = props => {
  const { t } = useTranslation('activity');
  return (
    <components.MenuList {...props}>
      {props.children}
      <div className={s.option}>
        <span>{t('date_picker.custom')}</span>
        {!props.hasValue && <img src={IconCheck} alt="check" width={24} height={24} />}
      </div>
    </components.MenuList>
  );
};
